import {useState, useEffect} from 'react';
import {onSnapshot, collection} from "firebase/firestore";
import { db } from '../firebase';
import pic from "../img/order.png";
import {Link, useHistory} from "react-router-dom";

export default function Orders({user, isUser}) {

    const [orders, setOrders] = useState();
    const [empty, setEmpty] = useState(false);

    useEffect(() => {
        if(user){
            const details = [];
            onSnapshot(collection(db, `users/${user.uid}/orders`), snap => {
                if(snap.empty){
                    setEmpty(true);
                }
                else{
                    snap.forEach((item) => {
                        details.push(...item.data().cart)
                    })
                    setOrders(details);
                }
            })
        }
    }, [user])

  return (
    <div className='order-page'>
        <h2 className='order-heading'>Orders</h2>
        {orders && <div className='order-listing'>
            <div className='order-list-top'>
                <p>Item Img</p>
                <p>Item Name</p>
                <p>Total Amount</p>
                <p>Status</p>
            </div>
            {orders.map((item) => {
                return <div className='order-item'>
                    <p><img src = {item.itemImg}/></p>
                    <p>{item.itemName}</p>
                    <p>₦ {item.totalAmount}</p>
                    <p className='delivered'>Delivered</p>
                </div>
            })}
        </div>}
        {empty && <div className='order-empty'>
            <img src = {pic}/>
            <p>No Orders Placed. <Link to= "/shop">Start Shopping Now</Link></p>
        </div>}
    </div>
  )
}
